<template>
  <div class="live">
    <category
      class="categoryLive"
      :list="itemList"
      :current="contentParams"
      @changeCurrent="changeParams"
    />
    <div class="infinite-list-wrapper" style="overflow: auto">
      <ul
        class="categoryContent"
        v-infinite-scroll="load"
        infinite-scroll-disabled="disabled"
      >
        <div style="margin: 0px 10px">
          <el-carousel height="105px" indicator-position="none">
            <el-carousel-item
              v-for="(item, key) in advertisementsList"
              :key="key"
            >
              <img
                @click="gotoURL(item.link)"
                :src="item.url"
                style="width: 100%; border-radius: 5px"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <li
          class="categoryDiv"
          v-for="(item, key) in contentInfoList"
          :key="key"
          @click="handleDetail(item.id, InfoObject.code)"
        >
          <div style="position: relative">
            <img
              :src="item.cover"
              style="
                width: 100%;
                border-radius: 10px;
                min-height: 100px;
                background: #e1e1e1;
              "
            />
            <div
              v-if="item.tag"
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                position: absolute;
                left: 0px;
                top: 0px;
              "
            >
              {{ item.tag }}
            </div>
            <div style="position: absolute; left: 10px; bottom: 10px">
              <div
                v-if="item.status == 'LIVE'"
                style="
                  display: flex;
                  border-radius: 5px;
                  color: #fff;
                  font-size: 12px;
                  background: rgba(1, 1, 1, 0.3);
                "
              >
                <div
                  style="
                    background-color: rgba(255, 51, 102, 1);
                    border-radius: 5px;
                    width: 48px;
                    height: 25px;
                    line-height: 25px;
                    text-align: center;
                  "
                >
                  直播中
                </div>
                <div style="margin: 0px 10px; height: 25px; line-height: 25px">
                  {{ item.playNumber | formatReadNumber }}观看
                </div>
              </div>
              <div
                v-if="item.status == 'RESERVATION'"
                style="
                  display: flex;
                  border-radius: 5px;
                  color: #fff;
                  font-size: 12px;
                  background: rgba(1, 1, 1, 0.3);
                "
              >
                <div
                  style="
                    background-color: rgba(255, 204, 51, 1);
                    border-radius: 5px;
                    width: 48px;
                    height: 25px;
                    line-height: 25px;
                    text-align: center;
                  "
                >
                  预约
                </div>
                <div style="margin: 0px 10px; height: 25px; line-height: 25px">
                  {{ item.playNumber | formatReadNumber }}人想看
                </div>
              </div>
              <div
                v-if="item.status == 'LOOK_BACK'"
                style="
                  display: flex;
                  border-radius: 5px;
                  color: #fff;
                  font-size: 12px;
                  background: rgba(1, 1, 1, 0.3);
                "
              >
                <div
                  style="
                    background-color: rgba(153, 153, 204, 1);
                    border-radius: 5px;
                    width: 48px;
                    height: 25px;
                    line-height: 25px;
                    text-align: center;
                  "
                >
                  回看
                </div>
                <div style="margin: 0px 10px; height: 25px; line-height: 25px">
                  {{ item.playNumber | formatReadNumber }}观看
                </div>
              </div>
            </div>
          </div>
          <div
            class="ellipsisT"
            style="margin-top: 5px; font-size: 16px; height: 40px"
          >
            {{ item.title }}
          </div>
          <div style="display: flex; text-align: center; margin: 10px 0px 0px">
            <span
              style="
                color: #ffae18;
                font-size: 12px;
                background: rgba(255, 241, 240, 1);
                padding: 0px 10px;
                border-radius: 5px;
                margin-right: 10px;
              "
              >社会</span
            >
            <span style="color: #888888; font-size: 13px">{{
              item.authorName
            }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as request from "@/utils/request";
import category from "@/components/category";
export default {
  components: {
    category,
  },
  created() {},
  mounted() {
    this.getInfoClass();
  },
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      InfoObject: {},
      itemList: [],
      contentInfoList: [],
      contentInfoListTotal: 0,
      currentContentId: "",
      contentParams: {
        categoryId: "",
        page: 1,
        size: 10,
      },
      advertisementsList: {},
      loading: false,
    };
  },
  filters: {
    formatReadNumber(val) {
      return val > 10000 ? `${(val / 10000).toFixed(2)}万` : val;
    },
  },
  computed: {
    noMore() {
      return (
        this.contentParams.page * this.contentParams.size >
        this.contentInfoListTotal
      );
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  methods: {
    getInfoClass() {
      request.getDicts().then((res) => {
        this.InfoObject = res.data.filter((item) => item.value === "直播")[0];
        this.getItemList();
      });
    },
    getCategoriesPoster() {
      request
        .getCategoriesPosters({
          id: this.contentParams.categoryId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.advertisementsList = res.data;
          }
        });
    },
    getItemList() {
      request.getCategoriesByType(this.InfoObject.code).then((res) => {
        this.itemList = res.data;
        this.itemList.length > 0 &&
          (this.contentParams.categoryId = this.itemList[0].id);
        this.getCategoriesPoster();
        this.getContentInfo();
      });
    },
    getContentInfo() {
      request.getResourceLives(this.contentParams).then((res) => {
        this.contentInfoList = this.contentInfoList.concat(res.data.list);
        this.contentInfoListTotal = res.data.total;
      });
    },
    changeParams(val) {
      this.contentParams = {
        categoryId: val,
        page: 1,
        size: 10,
      };
      this.getCategoriesPoster();
      this.contentInfoList = [];
      this.getContentInfo();
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.contentParams.page += 1;
        this.getContentInfo();
        this.loading = false;
      }, 2000);
    },
    handleDetail(id, type) {
      this.$router.push({ path: `/live/player/${id}?type=${type}` });
    },
  },
};
</script>
<style lang="less" scope>
.live {
  .categoryLive {
    height: 2.5rem;
    position: fixed;
    background: #fff;
    z-index: 9999;
  }
  .categoryContent {
    // height: 33rem;
    width: 100%;
    overflow-y: scroll;
    list-style: none;
    padding: 0px;
    padding-top: 2.5rem;
    .categoryDiv {
      padding: 0.5rem;
      width: 50%;
      display: inline-block;
      .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.9rem;
      }
    }
  }
  .ellipsisT {
    letter-spacing: 0;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2; /*要显示的行数*/
    -webkit-box-orient: vertical;
  }
}
</style>

